import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import BuildCircleOutlinedIcon from '@mui/icons-material/BuildCircleOutlined';

import MaintenanceDashboardBlock from './MaintenanceDashboardBlock';

const RequiredMaintenanceBlock = ({ totalFaulty, items, t, isHebrew }) => (
  <MaintenanceDashboardBlock
    title={t('required_maintenance') || 'Required Maintenance'}
    icon={<BuildCircleOutlinedIcon />}
    className='required-maintenance-block'
    headerAction={
      <Typography className='required-maintenance-header-total'>
        <Box
          component='span'
          sx={{
            direction: isHebrew ? 'rtl' : 'ltr',
            unicodeBidi: 'isolate',
            display: 'inline-flex',
            alignItems: 'baseline',
            gap: '4px',
          }}
        >
          <Box component='span'># {t('sensors') || 'Sensors'}:</Box>
          <Box component='span' dir='ltr'>
            {totalFaulty}
          </Box>
        </Box>
      </Typography>
    }
  >
    <Box className='required-maintenance-bars'>
      {items.map(({ label, count, note, ratio }) => (
        <Box
          className='required-maintenance-bar-row'
          key={label}
          data-maintenance-note={note}
        >
          {(() => {
            const barWidth = `${Math.max(
              0,
              Math.min(100, Number(ratio || 0) * 100)
            )}%`;
            const countDisplay =
              count === null || count === undefined ? '--' : count;

            return (
              <>
                <Typography className='required-maintenance-bar-label'>
                  {label}
                </Typography>

                <Box className='required-maintenance-bar-visual'>
                  <Box className='required-maintenance-bar-track'>
                    <Box className='required-maintenance-bar-inline'>
                      <Box
                        className='required-maintenance-bar-fill'
                        sx={{ width: barWidth }}
                      />
                      <Typography className='required-maintenance-bar-count'>
                        {countDisplay}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </>
            );
          })()}
        </Box>
      ))}
    </Box>
  </MaintenanceDashboardBlock>
);

RequiredMaintenanceBlock.propTypes = {
  totalFaulty: PropTypes.number,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      count: PropTypes.number,
      note: PropTypes.string.isRequired,
      ratio: PropTypes.number,
    })
  ),
  t: PropTypes.func.isRequired,
  isHebrew: PropTypes.bool,
};

RequiredMaintenanceBlock.defaultProps = {
  totalFaulty: 0,
  items: [],
  isHebrew: false,
};

export default RequiredMaintenanceBlock;
